var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"media-conversion-thumbnail"},[_c('span',[_c('i',{staticClass:"icon-Aula_watch mr-1"}),_vm._v(_vm._s(_vm.$getText('GALLERY_CONVERSION_IN_PROGRESS')))])])}
var staticRenderFns = []

export { render, staticRenderFns }